export default {
  name: 'marking--documentImport',
  apiService: 'shoes',
  apiPath: '/admin/document/upload',
  urlParamName: 'marking--documentImport',
};
